import React from 'react';
import styled from 'styled-components';

const StyledP = styled.p`
  width: 580px;
  line-height: 20px;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledDiv = styled.div`
  margin-bottom: 3px;
  font-size: 14px;
`;

interface Props {
  value: any;
  isWide: boolean;
}

export const InquiryListItemInquiryCategory = (props: Props) => {
  const { value, isWide } = props;

  return isWide ? <StyledP>{value}</StyledP> : <StyledDiv>{value}</StyledDiv>;
};
